// This func is agnostic about the baseUrl ending with slash or path starting with it!
export function getBaseUrl() {
  const envBaseUrl = import.meta.env.VITE_BASE_REST_URL;
  // Remove trailing slash from base if exists
  return envBaseUrl.endsWith('/') ? envBaseUrl.slice(0, -1) : envBaseUrl;
}
